import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpStoreExternalCost, HttpStoreExternalCostOptions} from '../http/budget.http'
import {ExternalCost} from '../types'

export const useStoreExternalCost = (
    options?: UseMutationOptions<ExternalCost, unknown, HttpStoreExternalCostOptions['payload']>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (payload: HttpStoreExternalCostOptions['payload']) => httpStoreExternalCost({payload}),
        ...options,
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.EXTERNAL_COSTS]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
